import { render, staticRenderFns } from "./code-input.vue?vue&type=template&id=5dce829a&scoped=true"
import script from "./code-input.vue?vue&type=script&lang=js"
export * from "./code-input.vue?vue&type=script&lang=js"
import style0 from "./code-input.vue?vue&type=style&index=0&id=5dce829a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce829a",
  null
  
)

export default component.exports